/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box, Stack, Typography } from "@mui/material";
import { DrawerLayout } from "../layout";
import { useTenantTranslation } from "hooks/formatters";
import { useBaskets } from "contexts/search/SearchContextProvider";
import {
  ChefGroup,
  ChemicalConstraint,
  ChemicalElement,
  ProductGroup,
} from "src/store/api/generatedApi";
import { ProductGroupChip } from "../chips/productGroup";
import { ChemistryGroupChip } from "../chips/chemistryGroup";
import { MaterialLimitsPanel } from "../mixDetails/MaterialLimits";
import { ChemicalTolerancesTable } from "./ChemicalTolerancesTable";

interface Props {
  productGroups: ProductGroup[];
  chemistryGroups?: ChefGroup[];
  chemicalConstraints: ChemicalConstraint[];
  elements: Record<number, ChemicalElement>;
  title: string;
  open: boolean;
  doClose: () => void;
}

export const ProductPanel = ({
  productGroups,
  chemistryGroups,
  chemicalConstraints,
  elements,
  title,
  open,
  doClose,
}: Props) => {
  const { t } = useTenantTranslation();
  const baskets = useBaskets();
  return (
    <DrawerLayout title={title} open={open} doClose={doClose} width={500}>
      <Stack gap={3}>
        <Stack gap={2}>
          <Typography variant="h6">{t("chemicalTolerances")}</Typography>
          <ChemicalTolerancesTable
            chemicalConstraints={chemicalConstraints}
            elements={elements}
          />
        </Stack>
        <Stack gap={2}>
          <Typography variant="h6">{t("productGroups")}</Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {productGroups.map((productGroup) =>
              productGroup.id !== null && productGroup.id !== undefined ? (
                <ProductGroupChip
                  key={productGroup.id}
                  name={productGroup.name}
                  steelGradeIds={productGroup.steel_grades.map(({ id }) => id)}
                />
              ) : null
            )}
          </Box>
        </Stack>
        {chemistryGroups !== undefined ? (
          <>
            <Stack gap={2}>
              <Typography variant="h6">{t("chemistryGroups")}</Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {chemistryGroups.map((chemistryGroup) =>
                  chemistryGroup.id !== undefined &&
                  chemistryGroup.id !== null ? (
                    <ChemistryGroupChip
                      name={chemistryGroup.name}
                      id={chemistryGroup.id}
                      key={chemistryGroup.id}
                    />
                  ) : null
                )}
              </Box>
            </Stack>
            {chemistryGroups.map((chemistryGroup) => (
              <Stack gap={2} key={chemistryGroup.id}>
                <Typography variant="h6">{t("materialLimits")}</Typography>
                <MaterialLimitsPanel
                  chefGroupId={chemistryGroup.id!}
                  basket={null}
                />
                {baskets.status === "success"
                  ? baskets.data.map((basket) => (
                      <MaterialLimitsPanel
                        key={basket.id}
                        chefGroupId={chemistryGroup.id!}
                        basket={basket}
                      />
                    ))
                  : null}
              </Stack>
            ))}
          </>
        ) : null}
      </Stack>
    </DrawerLayout>
  );
};
